export enum IntegrationType {
	EHR = 'ehr',
	MANUAL = 'manual',
}
